export function deriveVocabMappingStatus(progress) {
  if (!progress) return null;

  const { total = 0, mapped = 0, partial = 0, skipped = 0, unmapped = 0 } = progress;

  if (total === 0 || mapped + partial + skipped === 0) {
    return "not-mapped";
  }

  if (unmapped === 0 && partial === 0) {
    return "mapped";
  }

  return "mapping";
}

export function getVocabMappingStatusClassName(status) {
  switch (status) {
    case "mapped":
      return "text-green-800 bg-green-50 ring-green-600/20";
    case "mapping":
      return "text-yellow-800 bg-yellow-50 ring-yellow-600/20";
    case "not-mapped":
      return "text-gray-800 bg-gray-50 ring-gray-600/20";
    default:
      return "";
  }
}
